import { requisitions } from "./RequisitionOrders";
import { templateFolders } from "./Templates";

export const RequisitionService = {
  requisitions,
  templateFolders,
};
